export default __webpack_public_path__ + "static/media/gfgg.8ac4dce5.png";